import { Button, Modal } from "rsuite";
import React from "react";
import {DeleteButtonProps} from "../modals.model";

const DeleteConfirmationModal = ({ show, onHide, onConfirm, itemName }: DeleteButtonProps) => {
  return (
    <Modal open={show} onClose={onHide} backdrop="static" size="xs">
      <Modal.Header>
        <Modal.Title>Подтверждение удаления</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Вы уверены, что хотите удалить {itemName}? Это действие нельзя отменить.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} appearance="subtle">
          Отмена
        </Button>
        <Button onClick={onConfirm} appearance="primary" color="red">
          Удалить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
